let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("8JZKd"), load("gkHyQ"), load("1EXva")]).then(() => parcelRequire('4y97X'));